import { render, staticRenderFns } from "./LayerAddingPermissions.vue?vue&type=template&id=f6327e60&scoped=true&"
import script from "./LayerAddingPermissions.vue?vue&type=script&lang=js&"
export * from "./LayerAddingPermissions.vue?vue&type=script&lang=js&"
import style0 from "./LayerAddingPermissions.vue?vue&type=style&index=0&id=f6327e60&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6327e60",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VList } from 'vuetify/lib/components/VList';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VSubheader } from 'vuetify/lib/components/VSubheader';
installComponents(component, {VCheckbox,VCol,VList,VRow,VSpacer,VSubheader})
